import type { MarketVariants } from '@/lib/i18n'

export type Slide9bPracticeCopy = {
  contactName: string
  todayPrefix: string
  /** SMS body composed at render time around `fakeAmount`, `retailerName`,
   *  and `fakePhone`. We keep these as separate fields so per-market overrides
   *  can adjust just the variable bits without restating the full sentence. */
  smsBefore: string
  fakeAmount: string
  smsMid: string
  retailerName: string
  smsAfter: string
  fakePhone: string
  smsTrailer: string

  question: string
  selectAllNote: string

  route1Label: string
  route1Feedback: string
  route2Label: string
  route2Feedback: string
  route3Label: string
  route3Feedback: string
  route4Label: string
  route4Feedback: string

  submitLabel: string
}

export const copy: MarketVariants<Slide9bPracticeCopy> = {
  US: {
    contactName: 'Unknown Number',
    todayPrefix: 'Today 2:14 PM',

    smsBefore: 'ALERT: Your bank card was used for a ',
    fakeAmount: '$299.99',
    smsMid: ' purchase at ',
    retailerName: 'Best Buy',
    smsAfter: '. If this was NOT you, call us immediately on ',
    fakePhone: '1-800-042-1837',
    smsTrailer: ' to freeze your card.',

    question: 'Which of these are safe ways to verify?',
    selectAllNote: 'Select all that apply',

    route1Label: 'Call the number in the text message',
    route1Feedback:
      'That number came from the message itself. The scammer controls it.',
    route2Label: 'Open your banking app and check recent transactions',
    route2Feedback:
      'Your banking app is a channel you chose. If the charge is real, it will show here.',
    route3Label: 'Reply to the text asking for more details',
    route3Feedback:
      'Replying keeps the conversation on their terms. You are still inside their channel.',
    route4Label: 'Call the number on the back of your bank card',
    route4Feedback:
      'A number you already have is a number they cannot fake. This is independent verification.',

    submitLabel: 'Check my answers',
  },
  GB: {
    fakeAmount: '£299.99',
    retailerName: 'Currys',
    fakePhone: '0800 042 1837',
  },
  CA: {
    // CA inherits US fakeAmount ($299.99) and fakePhone (1-800 covers NANP).
    retailerName: 'Best Buy',
  },
  AU: {
    retailerName: 'JB Hi-Fi',
    fakePhone: '1800 042 837',
  },
  QA: {
    fakeAmount: 'QAR 1,090',
    retailerName: 'Lulu Hypermarket',
    fakePhone: '4404 1837',
  },
  ar: {
    contactName: 'رقم غير معروف',
    todayPrefix: 'اليوم 2:14 م',

    smsBefore: 'تنبيه: تم استخدام بطاقتك المصرفية لعملية شراء بقيمة ',
    fakeAmount: '1,090 ريال قطري',
    smsMid: ' في ',
    retailerName: 'لولو هايبرماركت',
    smsAfter: '. إذا لم تكن أنت، فاتصل بنا فوراً على الرقم ',
    fakePhone: '4404 1837',
    smsTrailer: ' لإيقاف بطاقتك.',

    question: 'أيّ من هذه الطرق آمنة للتحقق؟',
    selectAllNote: 'اختر كل ما ينطبق',

    route1Label: 'الاتصال بالرقم الوارد في الرسالة النصية',
    route1Feedback:
      'هذا الرقم جاء من الرسالة نفسها. والمحتال هو من يتحكم به.',
    route2Label: 'فتح تطبيق البنك ومراجعة العمليات الأخيرة',
    route2Feedback:
      'تطبيق البنك قناة اخترتها أنت. إن كانت العملية حقيقية، فستظهر هنا.',
    route3Label: 'الردّ على الرسالة وطلب مزيد من التفاصيل',
    route3Feedback:
      'الردّ يبقي المحادثة وفق شروطهم. ما زلت داخل قناتهم.',
    route4Label: 'الاتصال بالرقم المطبوع على ظهر بطاقتك المصرفية',
    route4Feedback:
      'الرقم الذي بحوزتك مسبقاً رقم لا يمكنهم تزييفه. هذا هو التحقق المستقل.',

    submitLabel: 'تحقّق من إجاباتي',
  },
}
